import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Card.css";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import { useNavigate } from "react-router-dom";
import Select_Product_By_Weight_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Weight_Modal";
import Heart_icon from "../heart_icon/Heart_icon";
import { encodeId } from "../../../utils/common";

const Product_Info_Card = ({ product, showQty }) => {
  const [favouriteProduct, setFavouriteProduct] = useState();

  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState({});
  return (
    <section className="Product_Info_Card_Section">
      <div className="Product_Info_Card">
        <div className="upper_image_section">
          <div
            className="card_img_holder"
            onClick={() => {
              navigate(`/product-description/${encodeId(product?.Product?.id)}`);
            }}
          >
            <img
              className=""
              src={process.env.REACT_APP_IMG_URL + product?.Product?.image}
              alt={product?.name}
            />
          </div>

          <div className="text_div">
            <div className="discont_div">
              <p className="discount_text">
                extra {product?.Discount_Type?.id === 1
                  ? `₹ ${product?.discount}`
                  : `${product?.discount}%`}{" "}
                Off
              </p>
            </div>

            {product?.company && (
              <div className="company_div">
                <p className="company_text">{product?.company}</p>
              </div>
            )}
          </div>
        </div>

        <div className="lower_text_section">
          <p
            className="product_name"
            onClick={() => {
              navigate(`/product-description/${encodeId(product?.Product?.id)}`);
            }}
          >
            {product?.Product?.name}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">
                ₹ {product?.Product?.Product_Variants[0]?.price}
                {/* {product?.Product?.Product_Variants?.length > 0
                  ? (
                      product?.Product?.Product_Variants[0]?.price *
                      (1 +
                        (product?.Product
                          ?.tax_percentage || 0) /
                          100)
                    ).toFixed(2)
                  : (
                      product?.Product?.price *
                      (1 +
                        (product?.Product?.tax_percentage ||
                          0) /
                          100)
                    ).toFixed(2)} */}
              </p>

              <p className="mrp">
                ₹{product?.Product?.Product_Variants[0]?.mrp}
                {/* {product?.Product?.Product_Variants?.length > 0
                  ? (
                      product?.Product?.Product_Variants[0]?.mrp *
                      (1 + (product?.Product?.tax_percentage || 0) / 100)
                    ).toFixed(2)
                  : (
                      product?.Product?.Product_Variants?.mrp *
                      (1 + (product?.Product.tax_percentage || 0) / 100)
                    ).toFixed(2)} */}
              </p>
              {/* <div className='discount_div'>
                                <p className='discount'>{product?.discount}</p>
                            </div> */}
            </div>

            {showQty && (
              <div className="kilo_main_div">
                <div
                  className="kilo_div"
                  type="button"
                  onClick={() => Setaddcartmodal(true)}
                >
                  <div>
                    <p className="kilo_text">
                      {product?.Product?.Product_Variants?.length > 0
                        ? product?.Product?.Product_Variants[0]?.name
                        : product?.Product?.Product_Variants?.name}{" "}
                      {product?.Product?.Unit?.name}
                    </p>
                  </div>

                  <div>
                    <p className="icon_p">
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="down_icon"
                      />
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="text-center btn_holder">
            <div className="" onClick={() => Setaddcartmodal(true)}>
              <Green_Btn btn_name="Add to Cart" leftIcon={faBasketShopping} />
            </div>
          </div>

          {/* <div
            className="favourite_div"
            onClick={() => setFavouriteProduct(product?.Product?.name)}
          >
            <FontAwesomeIcon
              icon={faHeart}
              className={`heart_icon ${
                product?.product_name == favouriteProduct ? "active" : ""
              }`}
            />
          </div> */}
          <Heart_icon product={product?.Product} />
        </div>
      </div>
      <Select_Product_By_Weight_Modal
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        product={product?.Product}
        show={addcartmodal}
        onHide={() => Setaddcartmodal(false)}
      />
    </section>
  );
};

export default Product_Info_Card;
